import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { get_automation_portal_url } from '@/utils/urls.ts';
import { AUTOMATION_PORTAL_KEY } from '@/utils/queryKeys.ts';
import { AutomationPortal } from '@/types/automations.ts';

export type UpdateAutomationPortalParams = {
  automationId: string;
  enabled?: boolean;
  public_slug?: string | null;
  title?: string;
  description?: string;
  run_error_message?: string;
};

const useUpdateAutomationPortal = (): UseMutationResult<
  AutomationPortal,
  AxiosError,
  UpdateAutomationPortalParams
> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ automationId, ...params }: UpdateAutomationPortalParams) => {
      const response = await apiClient.put(get_automation_portal_url(automationId), params);
      return response.data;
    },
    onSuccess: async (portal: AutomationPortal) => {
      queryClient.setQueryData(AUTOMATION_PORTAL_KEY(portal.automation_id), portal);
      await queryClient.invalidateQueries({
        queryKey: AUTOMATION_PORTAL_KEY(portal.automation_id),
      });
    },
  });
};

export default useUpdateAutomationPortal;
